import styled from 'styled-components';

export const FinancialsLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FinancialsToolbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 18px;
`;

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
`;

export const ContainerTypeFinancial = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const TextTable = styled.span`
  font-size: 13px;
  color: #434343;
`;

export const StatisticCardContainer = styled.div`
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.96) 0%,
    rgba(248, 252, 250, 0.96) 100%
  );
  padding: 18px;
  border-radius: 20px;
  box-shadow: 0 16px 40px rgba(18, 62, 51, 0.06);
  border: 1px solid rgba(24, 90, 66, 0.08);
  transition: all 0.3s;

  &:hover {
    box-shadow: 0 20px 46px rgba(18, 62, 51, 0.1);
    transform: translateY(-2px);
  }
`;
